<template>
  <div class="row sign-up-form-list-item">
    <div class="col-auto image-container">
      <b-img :src="imgUrl" alt="Center image"></b-img>
    </div>

    <div class="col-md-9 content-container">
      <h3 class="mb-3 customer-name-title">{{ title }}</h3>

      <div class="row customer-input-form">
        <div class="col-md-7 pl-0 pr-0">
          <text-input-group id="my-name" name="my-name" mandatory="true" label="" :placeholder="$t(LangConstants.generated_link_placeholder)" inlinerows="false" classes="bg-gray" btn_fa="clone" :btn_label="$t(LangConstants.copy_button_label)" btn_variant="solid-primary" btn_classes="" btn_width="100%" btn_readOnly="true" :default_value="this.$store.getters.spInstanceVueURL + url" @onClick="copyInputText"></text-input-group>
        </div>

        <div class="col-md-5">
          <div class="row">
            <div class="col">
              <my-button fa="pencil" :label="$t(LangConstants.edit_button_label)" variant="box-general-grey" classes="mb-2" height="48px" width="100%" @onClick="showEditForm"></my-button>
            </div>

            <div class="col">
              <my-button fa="trash" :label="$t(LangConstants.delete_button_label)" variant="box-general-grey" classes="mb-2" height="48px" width="100%" @onClick="deleteForm"></my-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row customer-description-section">
        <div class="col-md-12">
          <h5 class="mt-3 mb-3 customer-description-title">
            {{ descTitle }}
          </h5>
          <p class="customer-description form-base p-3">
            {{ description }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-12"><hr /></div>
  </div>
</template>

<script>
import "../../assets/scss/sign-up-form-list-item.scss";
import MyButton from "../atoms/Button.vue";
import TextInputGroup from "./TextInputGroup.vue";
import Constants from "../../constants/index";

export default {
  name: "sign-up-form-list-item",
  components: {
    MyButton,
    TextInputGroup,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    imgUrl: {
      type: String,
      required: true,
    },
    descTitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      text: "",
    };
  },
  created() {},

  methods: {
    showEditForm() {
      this.$emit("showEditForm");
    },
    deleteForm() {
      this.$emit("deleteForm");
    },
    copyInputText() {
      this.$emit("copyInputText");
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },
};
</script>
